import { render } from "./AddPaymentView.vue?vue&type=template&id=efa5af82&scoped=true"
import script from "./AddPaymentView.vue?vue&type=script&lang=js"
export * from "./AddPaymentView.vue?vue&type=script&lang=js"

import "./AddPaymentView.vue?vue&type=style&index=0&id=efa5af82&scoped=true&lang=css"

import exportComponent from "/Users/kokleng/Documents/Dollar/core_system/from_gitlab/pos-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa5af82"]])

export default __exports__